import { render, staticRenderFns } from "./SampleByQuotationListTable.vue?vue&type=template&id=315b808d&scoped=true"
import script from "./SampleByQuotationListTable.vue?vue&type=script&lang=js"
export * from "./SampleByQuotationListTable.vue?vue&type=script&lang=js"
import style0 from "./SampleByQuotationListTable.vue?vue&type=style&index=0&id=315b808d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315b808d",
  null
  
)

export default component.exports